<script>
import LocationCard from "./LocationCard.svelte"
import RegionCard from "./RegionCard.svelte";

export let locations

const createLocationsByRegionDict = ( locations ) => {
	return locations.reduce( ( dict, loc ) => {

		const region = loc.state

		// create entry for state
		if ( ! (region.id in dict) ) {
			dict[region.id] = loc.state
			dict[region.id].locations = []
		}

		// add location
		dict[region.id].locations.push( loc )

		return dict

	}, {} )
}

$:regions = Array.isArray( locations ) && locations.length > 0
	? createLocationsByRegionDict( locations )
	: []

</script>

<div class="location-list-simple">
	<div class="location-list">
		<div class="location-list__items">

			{#each Object.keys( regions ) as rid}

				<div class="location-list__item">
					<RegionCard region={regions[rid]}/>
				</div>

				{#each regions[rid].locations as location}
					<div class="location-list__item">
						<LocationCard {location} cardStyle="horizontal"/>
					</div>
				{/each}

			{/each}

		</div>
	</div>
</div>

